export const INITIAL_STATE = {
  buildingId: '',
  longitude: '',
  latitude: '',
};
